<template>
	<div class="px-4 mt-2 file-input-field">
		<v-file-input
			v-if="!isUploadedImage"
			outlined
			show-size
			class="file-input"
			truncate-length="30"
			:label="label"
			color="deep-purple accent-4"
			prepend-icon="mdi-paperclip"
			:placeholder="placeholder"
			:accept="accept"
			:loading="loading"
			@change="filePicked"
			v-bind="$attrs"
		>
			<template v-slot:progress>
				<br />
				<v-progress-linear v-model="uploadProgress" height="25">
					<strong>{{ Math.ceil(uploadProgress) }}%</strong>
				</v-progress-linear>
			</template>
		</v-file-input>
		<div v-else class="display-flex lfex-row flex-justify-space-between flex-align-center">
			<a :href="uploadedFile" target="_blank">Uploaded image</a>
			<AnemicButton class="delete-button" @click="onFileUploaded(null)">Remove File</AnemicButton>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AppFileUpload',
	props: {
		uploadedFile: { type: String },
		placeholder: { type: String },
		accept: { type: String },
		uploadFunc: { type: Function },
		label: { type: String, default: 'Upload file' },
	},
	computed: {
		isUploadedImage() {
			return !!this.uploadedFile;
		},
	},
	methods: {
		async filePicked(file) {
			this._uploadFile(file);
		},
		async _uploadFile(file) {
			if (!file) {
				this.onFileUploaded(null);
				return;
			}
			this.loading = true;
			try {
				const uploadedFileUrl = await this.uploadFile(file);
				this.onFileUploaded(uploadedFileUrl);
				console.log(`Uploaded file success:`, uploadedFileUrl);
			} catch (err) {
				console.log('err = ', err);
				alert('Error while uploading file');
			} finally {
				this.loading = false;
			}
		},
		async uploadFile(file) {
			const r = await this.uploadFunc(file);
			return r;
		},
		onFileUploaded(value) {
			this.$emit('onFileUploaded', value);
		},
	},
	data() {
		return {
			loading: false,
			uploadProgress: 0,
			outlinedInput: false, //Customization for WidgetFieldMixin default behavior
		};
	},
};
</script>

<style scoped lang="scss">
.delete-button {
	width: 89px;
	height: 25px !important;
	color: var(--button-text);
	font-size: 12px !important;
	border: 1px solid var(--button-text);
	background: var(--bg-color) !important;
}

.file-input {
	::v-deep {
		.v-label {
			top: 8px !important;
		}
		.v-input__prepend-outer {
			margin-top: 6px !important;
		}
		.v-progress-linear {
			width: 40px !important;
		}
		.v-input__append-inner {
			margin-top: 6px !important;
		}

		.v-text-field__slot {
			max-width: calc(100% - 80px);

			.v-file-input__text {
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		.v-file-input .v-file-input__text {
			display: inline;
		}
		.v-progress-linear__content {
			margin-top: 6px;
		}
	}
}
</style>
